import { axiosInstance as axios } from "./axiosInstance";

export const companionPurposePassion = (step, values) => {
    const data = {
        step,
        values,
    }
    return axios.post(`/api/v2/companion/purpose/passion`, data)
}

export const companionPersonalityLook = (lookAndFeelAttributes) => {
    return axios.post(`/api/v2/companion/personality/look`, lookAndFeelAttributes);
}